export default "__VITE_ASSET__Bo0UO6Ks__"